import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { delay } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private _loading = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this._loading.asObservable().pipe(delay(1));
  constructor() {
  }
  /**
   * Shows Loading screen
   */
  show() {
    this._loading.next(true);
  }
    /**
   * hides Loading screen
   */
  hide() {
    this._loading.next(false);
  }

}
